import React, { useState } from 'react';
import config from '../../config/config';
import Dialog from './Dialog';

/**
 * Kërkesa për demonstrim.
 *
 * Shkon te `POST /api/support/public` — e njëjta derë publike që përdor kutia e
 * ndihmës (kufi kërkesash për email/IP, fushë e fshehur kundër robotëve).
 * «E morëm» shfaqet VETËM kur serveri e konfirmon; çdo dështim thuhet hapur,
 * bashkë me adresën e mbështetjes nga faqet ligjore, që njeriu të mos presë
 * një përgjigje që s'do të vijë.
 *
 * Serveri i kthen gabimet vetëm shqip, ndaj mesazhi zgjidhet nga statusi, në
 * gjuhën e faqes. Trupi i mesazhit e mban gjuhën, që mbështetja të përgjigjet në të.
 */

const API = (config.baseUrl || '').replace(/\/+$/, '');
const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default function DemoRequestDialog({ t, lang, onClose }) {
  const d = t.demoDialog;
  const [form, setForm] = useState({ name: '', company: '', email: '', message: '' });
  const [website, setWebsite] = useState(''); // fusha e fshehur
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const set = (k) => (e) => {
    const { value } = e.target; // lexohet tani: përditësuesi mund të ekzekutohet më vonë
    setForm((f) => ({ ...f, [k]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    const email = form.email.trim();
    const company = form.company.trim();
    if (!EMAIL.test(email) || !company) {
      setError(d.errFields);
      return;
    }
    setBusy(true);
    setError('');
    const body = [
      `Kërkesë për demonstrim (faqja prezantuese, gjuha: ${lang})`,
      `Firma: ${company}`,
      form.message.trim() ? `\n${form.message.trim()}` : '',
    ].filter(Boolean).join('\n');
    try {
      const res = await fetch(`${API}/api/support/public`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, name: form.name.trim(), body, website }),
      });
      if (res.ok) setSent(true);
      else setError(res.status === 400 ? d.errFields : res.status === 429 ? d.errRate : d.errSend);
    } catch (_) {
      setError(d.errNetwork);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog labelledBy="nxp-demo-title" describedBy="nxp-demo-desc" closeLabel={d.close} onClose={onClose} focusKey={sent}>
      {sent ? (
        <div className="nxp-dialog-done" role="status">
          <h2 id="nxp-demo-title" className="nxp-h3">{d.doneTitle}</h2>
          <p id="nxp-demo-desc">{d.doneDesc(form.email.trim())}</p>
          <button type="button" className="nxp-btn nxp-btn-primary" onClick={onClose} data-autofocus>{d.close}</button>
        </div>
      ) : (
        <form onSubmit={submit} noValidate>
          <h2 id="nxp-demo-title" className="nxp-h3">{d.title}</h2>
          <p id="nxp-demo-desc" className="nxp-dialog-desc">{d.desc}</p>

          <label className="nxp-field">
            <span>{d.name}</span>
            <input type="text" autoComplete="name" value={form.name} onChange={set('name')} maxLength={120} />
          </label>
          <label className="nxp-field">
            <span>{d.company} <em aria-hidden="true">*</em></span>
            <input type="text" autoComplete="organization" required aria-required="true" value={form.company} onChange={set('company')} maxLength={160} />
          </label>
          <label className="nxp-field">
            <span>{d.email} <em aria-hidden="true">*</em></span>
            <input type="email" autoComplete="email" required aria-required="true" value={form.email} onChange={set('email')} maxLength={160} />
          </label>
          <label className="nxp-field">
            <span>{d.message}</span>
            <textarea rows={3} value={form.message} onChange={set('message')} maxLength={2000} placeholder={d.messagePh} />
          </label>
          <input
            className="nxp-hp"
            type="text"
            name="website"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            value={website}
            onChange={(e) => setWebsite(e.target.value)}
          />

          {error && <p className="nxp-error" role="alert">{error}</p>}

          <button type="submit" className="nxp-btn nxp-btn-primary nxp-btn-block" disabled={busy}>
            {busy ? d.sending : d.send}
          </button>
        </form>
      )}
    </Dialog>
  );
}
